import { concat, fn } from '@ember/helper';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

import { t } from 'ember-intl';
import momentFormat from 'ember-moment/helpers/moment-format';
import { eq } from 'ember-truth-helpers';

import Button from 'umg-ember-backend/components/ui/button';
import { getBem } from 'umg-ember-backend/utils/get-bem';

import { Assertions } from './assertions';
import { ResultsOverview } from './results-overview';
import { Score } from './score';
import styles from './styles.module.css';

const tScope = 'record_detail.forms.a11y_report.';
const bem = getBem(styles);

export default class A11yReport extends Component {
  @tracked severity = false;

  toggleSeverity = (severity) => {
    this.severity = severity;
  };

  filterAssertions = (assertions) => {
    if (this.severity) {
      assertions = assertions.filter(
        (assertion) => assertion.meta[this.severity] >= 1,
      );
    }

    return assertions;
  };

  <template>
    <div class={{(bem)}}>
      {{#if @model.report.hasError}}
        <h2>{{t (concat tScope 'scan-error-headline')}}</h2>
        <p>{{@model.report.error}}</p>
      {{else if @model.report.status}}
        <div class={{bem 'header'}}>
          <div class={{bem 'score'}}>
            <Score @score={{@model.report.score}} />
          </div>
          <div class={{bem 'overview'}}>
            <strong>{{t (concat tScope 'title')}}</strong>
            {{@model.pageInfo.title}}<br />
            <strong>{{t (concat tScope 'url')}}</strong>
            {{@model.pageInfo.url}}<br />
            <strong>{{t (concat tScope 'elements')}}</strong>
            {{@model.pageInfo.elementCount}}<br />
            <strong>{{t (concat tScope 'date')}}</strong>
            {{momentFormat @model.report.lastScan 'L LT' allow-empty=true}}<br
            /><br />
            <ResultsOverview @overview={{@model.overview}} />
          </div>
        </div>

        <div class={{bem 'filters'}}>
          <div class={{bem 'filter'}}>
            {{t (concat tScope 'outcome')}}

            <Button
              @size='small'
              @label={{t (concat tScope 'severity.all')}}
              @style={{if (eq this.severity false) 'outline' 'grey'}}
              style={{if (eq this.severity false) 'font-weight: bold'}}
              {{on 'click' (fn this.toggleSeverity false)}}
            />

            <Button
              @size='small'
              @label={{t (concat tScope 'severity.passed')}}
              @style={{if (eq this.severity 'passed') 'success' 'grey'}}
              style={{if (eq this.severity 'passed') 'font-weight: bold'}}
              {{on 'click' (fn this.toggleSeverity 'passed')}}
            />

            <Button
              @size='small'
              @label={{t (concat tScope 'severity.warning')}}
              @style={{if (eq this.severity 'warning') 'warning' 'grey'}}
              style={{if (eq this.severity 'warning') 'font-weight: bold'}}
              {{on 'click' (fn this.toggleSeverity 'warning')}}
            />

            <Button
              @size='small'
              @label={{t (concat tScope 'severity.failed')}}
              @style={{if (eq this.severity 'failed') 'danger' 'grey'}}
              style={{if (eq this.severity 'failed') 'font-weight: bold'}}
              {{on 'click' (fn this.toggleSeverity 'failed')}}
            />
          </div>
        </div>

        {{#each @model.modules as |module|}}
          <h2 class={{bem 'subheadline'}}>
            {{t (concat tScope module.name)}}
          </h2>
          <Assertions @assertions={{this.filterAssertions module.assertions}} />
        {{/each}}
      {{else}}
        <h2>{{t (concat tScope 'scan-in-progress-headline')}}</h2>
        <p>{{t (concat tScope 'scan-in-progress-message')}}</p>
      {{/if}}
    </div>
  </template>
}
